import { Component, EventEmitter, Output , Input } from '@angular/core';
import Swal from 'sweetalert2';
import { SecurityService } from 'app/services/security/security.service';
import {HttpErrorResponse} from '@angular/common/http';
import { MessagesTitles, MessagesStatus } from '../../models/messages';
import { FormGroup, FormControl } from '@angular/forms';
import { LoginService } from '../../services/login/login.service';
import {MatSnackBar} from '@angular/material';


@Component({
  selector: 'app-cambiar-foto',
  templateUrl: './cambiar-foto.component.html',
  styleUrls: ['./cambiar-foto.component.scss'],
  providers:[MessagesTitles, MessagesStatus]
})
export class CambiarFotoComponent   {

  loading: boolean = true;
  archivoEnBase64 : any;
  public imagePath;
  imgURL: any;
  public message: string;
  envImage :any=[];
  ipAddress:any;
  file:any;
  user:any;
  NameFile:any="Select an Image"
  formAdjunto : FormGroup;

  @Input() accept = 'image/*';
  @Output() CerrarPopUpCambiarFoto: EventEmitter<boolean>;
  @Output() refresh = new EventEmitter<any>();

  constructor(private securityService: SecurityService,
    private msgTitulos : MessagesTitles,
    private loginService:LoginService,
    private msgStatus:MessagesStatus ,
    public snackBar: MatSnackBar) { 
    this.CerrarPopUpCambiarFoto = new EventEmitter();
    this.ipAddress = JSON.parse(sessionStorage.getItem('PUBLIC-IP'));
    this.user = JSON.parse(sessionStorage.getItem('UserActive'));

    this.formAdjunto = new FormGroup({
      'id_user' : new FormControl(''),
      'file_name' : new FormControl(''),
      'file_content' : new FormControl(''),
      'file_type' : new FormControl('')
    })
  }

  

  preview(files) {
    this.message = '';
    if (files.length === 0)
      return;
 
    var mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.openSnackBar('Only images are allowed','close')
      return;
    }
 
    var reader = new FileReader();
    this.imagePath = files;
    reader.readAsDataURL(files[0]); 
    reader.onload = (_event) => { 
    this.imgURL = reader.result; 
    }

    this.file = this.imagePath[0];
    this.NameFile = this.file.name
    this.loading = false;
    let fileReader: FileReader = new FileReader();
    var base64;
    var archivo64;
    var self = this;
    fileReader.onload =  function(fileLoadedEvent) {
              base64 = fileLoadedEvent.target['result'];
              archivo64 = base64.split(',',2);
              self.archivoEnBase64 = archivo64[1];
           };
        fileReader.readAsDataURL(this.file);

  }
  CerrarPopUpfpFP(){
    this.CerrarPopUpCambiarFoto.emit();
  }

  CambiarFoto(){
    this.formAdjunto.controls['id_user'].setValue(this.user.id_user);
    this.formAdjunto.controls['file_name'].setValue(this.user.Usuario);
    this.formAdjunto.controls['file_content'].setValue(this.archivoEnBase64);
    this.formAdjunto.controls['file_type'].setValue(this.file.type);
      Swal.fire({
        title: 'Espere',
        text:'Guardando la información',
        type:'info',
        allowOutsideClick:false
      });
      Swal.showLoading();
      this.securityService.SubirFotoUser(this.formAdjunto.getRawValue())
          .subscribe(resp => {
            Swal.fire({
              title: "Éxito",
              text: "Photo guardado correctamente.",
              type: "success",
              allowOutsideClick: false
            }).then(res =>{
              if (res.value == true ){
                this.loginService.uploadImage = true;
                sessionStorage.setItem('uploadFoto',JSON.stringify(this.imgURL)); 
                this.CerrarPopUpCambiarFoto.emit();
                this.refresh.emit();         
              }
            });
          },(err: HttpErrorResponse)=> {   
            this.msgStatus.getMessage(err.status); 
       
            Swal.fire({
              title: this.msgTitulos.Error,
              text: "Image not saved. "+this.msgStatus.message,
              type: "error",
              allowOutsideClick: true
            })
          });
  }

  onClick() {
    const fileUpload = document.getElementById('fileUpload') as HTMLInputElement;
    fileUpload.onchange = () => {
      this.preview(fileUpload.files)
    };
  fileUpload.click();
}

openSnackBar(message,action) {
  this.snackBar.open(message, action, {
    duration: 5000,
    verticalPosition:'top', // 'top' | 'bottom'
    horizontalPosition: 'center', //'start' | 'center' | 'end' | 'left' | 'right'
    panelClass: ['red-snackbar'],
});
}

}



